import React from 'react'
import { PrismicLink } from '@prismicio/react'
import { GatsbyImage } from 'gatsby-plugin-image'

import { FadeIn } from './fadeIn'
import Thumbnail from './thumbnail'

const CategoryCard = ({ item }) => {
  const itemData = item.node.data
  const authorData = itemData.author?.document.data
  const publishDate = item.node.first_publication_date_formatted
  let timeToRead

  if (item.node.type === 'blogpost') {
    const wordsPerMinute = 200
    let wordCount = itemData.page_text?.text.split(' ').length
    timeToRead = Math.ceil(wordCount / wordsPerMinute)
  }
  return (
    <li className={`component-card group`}>
      <FadeIn
        x={0}
        y={50}
        className='cease relative flex transform flex-col overflow-hidden rounded-t-lg h-full rounded-b-sm transition duration-300 ease-in-out md:hover:scale-105 hover:shadow-lg hover:shadow-river/30 hover:shadow-river-800/10 group-hover:md:scale-105 group-hover:shadow-lg'>
        <div className='flex flex-1 flex-col'>
          <PrismicLink className='flex flex-1 flex-col' href={item.node.url}>
            <div className='relative flex-shrink-0 overflow-hidden'>
              <Thumbnail image={itemData.page_image} alt={itemData.page_image.alt} />
            </div>
            <div className='m-6 lg:m-8 flex flex-1 flex-col'>
              <div className='mb-6 space-y-4 prose lg:prose-lg'>
                <h3>{itemData.page_title.text}</h3>
                <div className='mb-6 mt-3'>
                  {itemData.page_text.text.split(' ').slice(0, 20).join(' ')}
                  &hellip;
                </div>
              </div>
              {authorData && (
                <div className='mt-auto flex author'>
                  <div className='relative mr-4 flex-shrink-0'>
                    <GatsbyImage className='h-16 w-16 rounded' image={authorData.image.gatsbyImageData} alt={authorData.image.alt || ''} />
                  </div>
                  <div className='justify-center flex flex-col'>
                    <p className='font-bold text-lg'>{authorData.name}</p>
                    <div className='opacity-90'>
                      {publishDate} &middot; {timeToRead} min read
                    </div>
                  </div>
                </div>
              )}
            </div>
          </PrismicLink>
        </div>
      </FadeIn>
    </li>
  )
}

export default CategoryCard
